module.exports = __webpack_public_path__ + "assets/img/100607.987af640.svg";